import { useMutation, useQueryClient } from "@tanstack/vue-query";
import BucketLock from "@/services/bucket/bucket-lock";
import { CreateBucketLockOverride } from "@/dtos/BucketLock.dto";

export function useCreateBucketLockOverride() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: CreateBucketLockOverride) => {
      const result = await BucketLock.createBucketLockOverride(data);
      if (!result.data.status) {
        throw new Error(result.data.msg || "Failed to create bucket lock override");
      }
      return result.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["bucketLockOverrides"] });
      queryClient.invalidateQueries({ queryKey: ["bucketLockStatus"] });
    },
  });
}
